import { t } from "@/i18n-js/instance";
import type { ResourceSection } from "../shared/types";
import desktopAppIcon from "./desktop-app.svg";
import mobileAppIcon from "./mobile-app.svg";
import { useCustomAppSection } from "./useCustomAppSection";

const localeRoot = "community_onboarding.new_checklist.circle_app_links";

export const useLinkSections = (): ResourceSection[] => {
  const customAppSection = useCustomAppSection();

  return [
    {
      icon: desktopAppIcon,
      title: t(`${localeRoot}.sections.desktop_app.title`),
      description: t(`${localeRoot}.sections.desktop_app.description`),
      iconAlt: t(`${localeRoot}.sections.desktop_app.icon_alt`),
      link: "https://circle.so/desktop-app",
    },
    {
      icon: mobileAppIcon,
      title: t(`${localeRoot}.sections.mobile_app.title`),
      description: t(`${localeRoot}.sections.mobile_app.description`),
      iconAlt: t(`${localeRoot}.sections.mobile_app.icon_alt`),
      link: "https://circle.so/mobile",
    },
    customAppSection,
  ];
};
